<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <comparables-properties-grid [hidden]="!showGrid" [workspace]="this"></comparables-properties-grid>
    <properties-form [oid]="oid" *ngIf="!showGrid && oid !== null"
                   [workspace]="this"
                   [showPrevBtn]="previousButtonEnabled"
                   [showNextBtn]="nextButtonEnabled"
                   (showPrevious)="showPrevious()"
                   (showNext)="showNext()">
    </properties-form>
  </div>
</div>
